
<template>
  <div>
    <Row :gutter="16" type="flex" justify="center" align="top">
      <Col span="24" style="border: #fff 1px solid; margin:5px;">
      <Form ref="userDetailForm" :model="userDetail" :label-width="100" :rules="ruleValidate">
        <Row type="flex" justify="center" :gutter="16">
          <Col span="18">
          <FormItem prop="username" label="用户名">
            <Input type="text" v-model="userDetail.username" placeholder="用户名" disabled>
            <Icon type="md-person" size="14" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col>
          <Col span="18">
          <FormItem label="登录密码：">
            <Button type="primary" size="small" @click="showEditPassword">修改密码</Button>
          </FormItem>
          </Col>
          <!-- <Col span="9">
          <FormItem prop="familyName" label="姓">
            <Input type="text" v-model="userDetail.familyName" placeholder="姓">
            <Icon type="md-person" size="14" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col> -->
          <Col span="18">
          <FormItem prop="name" label="姓名">
            <Input type="text" v-model="userDetail.name" placeholder="名">
            <Icon type="md-person" size="14" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col>
          <Col span="9">
          <FormItem prop="mobile" label="手机">
            <Input type="text" v-model="userDetail.mobile" placeholder="手机" maxlength="11">
            <Icon type="md-call" size="14" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col>
          <Col span="9">
          <FormItem prop="email" label="电子邮件">
            <Input type="text" v-model="userDetail.email" placeholder="电子邮件">
            <Icon type="md-mail" size="14" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col>
          <Col span="18">
          <FormItem prop="idCard" label="身份证号码">
            <Input type="text" v-model="userDetail.idCard" placeholder="身份证号码" maxlength="18">
            <Icon type="md-person" size="14" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col>
          <Col span="18">
          <FormItem prop="imgPath" label="头像">
            <Input type="text" v-model="userDetail.imgPath" placeholder="头像" style="display:none">
            </Input>
            <Row type="flex" justify="start" align="middle">
              <img :src="userDetail.imgPath"
                style="width:32px;height:32px;background: #619fe7;margin: 0 10px;border-radius:50%;">
              <Button type="primary" shape="circle" icon="md-add" @click="showModal()"></Button>
            </Row>
          </FormItem>
          </Col>
          <Col span="18">
          <FormItem prop="discTitle" label="个人介绍标题">
            <Input type="text" v-model="userDetail.discTitle" placeholder="个人描述标题">
            <Icon type="md-create" size="14" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col>
          <Col span="18">
          <FormItem prop="discDetail" label="个人介绍">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 10}" v-model="userDetail.discDetail"
              placeholder="个人介绍">
            </Input>
          </FormItem>
          </Col>
          <Col span="18">
          <FormItem prop="register_time" label="注册时间">
            <Input type="text" v-model="registerTime" placeholder="注册时间" disabled>
            <Icon type="md-time" size="16" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col>
          <!-- <Col span="9">
          <FormItem prop="lastLogin" label="最后登录时间">
            <Input type="text" v-model="userDetail.lastLogin" placeholder="最后登录时间" disabled>
            <Icon type="md-time" size="16" slot="prepend"></Icon>
            </Input>
          </FormItem>
          </Col> -->
          <hr style="margin-bottom:15px;">
          </hr>
          <Col span="18">
          <FormItem prop="roleIds" label="角色">
            <Select ref="roleSelect" v-model="roles" multiple disabled>
              <Option v-for="option in roleOptions" :value="option.value" :key="option.value">{{ option.label }}
              </Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="9" offset="15">
          <FormItem>
            <Button type="primary" @click="handleSubmit('userDetailForm')" :disabled="isSubmitDisabled">提交</Button>
            <Button type="default" @click="closeMe()" style="margin-left: 8px">返回</Button>
          </FormItem>
          </Col>
        </Row>
      </Form>
      </Col>
    </Row>
    <Modal title="设置头像" v-model="modalShow" :mask-closable="false" :closable="false" @on-hidden="handlecrop1"
      class-name="vertical-center-modal" width="80%">
      <Row :gutter="10" class="image-editor">
        <Col span="14" class="image-editor-con1">
        <div class="cropper" style="max-height:100%;">
          <img id="cropimg1" alt="">
        </div>
        </Col>
        <Col span="10" class="image-editor-con1">
        <Row type="flex" justify="center" align="middle" class="image-editor-con1-preview-con">
          <div id="preview1"></div>
        </Row>
        <div class="image-editor-con1-btn-con margin-top-10">
          <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg" @change="handleChange1"
            id="fileinput1" class="fileinput" />
          <label class="filelabel" for="fileinput1">
            <Icon type="md-image" size="20"></Icon>&nbsp;选择图片
          </label>
          <ButtonGroup style="margin-left: 16px;">
            <Button @click="cropper1.zoom(0.1)" type="primary">
              <Icon :size="14" type="md-add"></Icon>
            </Button>
            <Button @click="cropper1.zoom(-0.1)" type="primary">
              <Icon :size="14" type="md-remove"></Icon>
            </Button>
          </ButtonGroup>
        </div>
        </Col>
      </Row>
    </Modal>
    <Modal v-model="editPasswordModal" :closable='false' :mask-closable=false :width="500" @on-hidden="handlePassword">
      <h3 slot="header" style="color:#2D8CF0">修改密码</h3>
      <Form ref="editPasswordForm" :model="editPasswordForm" :label-width="100" label-position="right"
        :rules="passwordValidate">
        <FormItem label="原密码" prop="oldPass" :error="oldPassError">
          <Input v-model="editPasswordForm.oldPass" placeholder="请输入现在使用的密码" type="password"></Input>
        </FormItem>
        <FormItem label="新密码" prop="newPass">
          <Input v-model="editPasswordForm.newPass" placeholder="请输入新密码，至少8位字符" type="password"></Input>
        </FormItem>
        <FormItem label="确认新密码" prop="rePass">
          <Input v-model="editPasswordForm.rePass" placeholder="请再次输入新密码" type="password"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="cancelEditPass">取消</Button>
        <Button type="primary" @click="saveEditPass" :disabled="isSubmitDisabled">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Cropper from 'cropperjs'
import '../authority/cropper.min.css'
import common from '@/libs/common.js'

export default {
  name: 'userDetailEdit',
  data () {
    // 身份证号验证
    const validateId = (rule, value, callback) => {
        if(value) {
            if(!common.checkIdCard(value)) {
                callback(new Error('请填写正确格式的证件号码'));
            }else{
                callback();
            }
        }else{
            callback();
        }
    }
    // 手机号验证
    const validatePhone = async (rule, value, callback) => {
        if(value) {
            if(!common.checkPhone(value)){
                callback(new Error('请填写正确格式的手机号码'));
            }else{
                let res = await this.checkMobile(value);
                if(res.data.code == -1) {
                    callback(new Error('系统存在相同手机号'))
                }else{
                    callback();
                }
            }
        }else{
            callback(new Error('请填写手机号码'))
        }
    }
    return {
      isSubmitDisabled: false,
      userDetail: {
        id: null,
        username: null,
        familyName: null,
        name: null,
        mobile: null,
        email: null,
        imgPath: null,
        lastLogin: null,
        discTitle: null,
        discDetail: null,
        registerTime: null,
        roleIds: '',
        roleNames: ''
      },
      roleOptions: [],
      ruleValidate: {
        // familyName: [
        //   {
        //     required: true,
        //     message: '姓不能为空！',
        //     trigger: 'blur'
        //   }
        // ],
        name: [
          {
            required: true,
            message: '姓名不能为空！',
            trigger: 'blur'
          }
        ],
        mobile: [{required: true, validator: validatePhone}],
        idCard: [{validator: validateId}],
      },
      modalShow: false,
      editPasswordModal: false,
      oldPassError: '',
      cropper1: {},
      option1: {
        showCropedImage: false,
        cropedImg: ''
      },
      cropdata1: {
        x: '',
        y: '',
        w: '',
        h: '',
        deg: '',
        scaleX: '',
        scaleY: ''
      },
      editPasswordForm: {
        oldPass: '',
        newPass: '',
        rePass: ''
      },
      passwordValidate: {
        oldPass: [
          {
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          }
        ],
        newPass: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          {
            min: 8,
            message: '请至少输入8个字符',
            trigger: 'blur'
          },
          {
            max: 32,
            message: '最多输入32个字符',
            trigger: 'blur'
          }
        ],
        rePass: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur'
          },
          {
            validator: this.valideRePassword,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    roles: {
      get () {
        return this.userDetail.roleIds === null ? [] : this.userDetail.roleIds.split(',')
      },
      set () {}
    },
    registerTime() {
          return this.userDetail.registerTime ? this.dayjs(this.userDetail.registerTime).format('YYYY-MM-DD HH:mm') : '';
      }
  },
  methods: {
    init () {
      this.initRoles()
      this.initUserDetail()
    },
    initUserDetail () {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(response => {
        this.userDetail = response.data
      }).catch()
    },
    showEditPassword () {
      this.editPasswordModal = true
    },
    cancelEditPass () {
      this.editPasswordModal = false
    },
    saveEditPass () {
      this.$refs['editPasswordForm'].validate(valid => {
        if (valid) {
          this.isSubmitDisabled = true
          let msg = this.$Message.loading({
            content: '正在更新密码',
            duration: 0
          })
          const data = {
            userId: this.userDetail.userId,
            oldPassword: this.editPasswordForm.oldPass,
            newPassword: this.editPasswordForm.newPass
          }
          this.$http.put('/api/system/cscpUserPassword', data).then(response => {
            msg()
            this.isSubmitDisabled = false
            if (response.data.token) {
              this.$Message.success('更新密码成功！')
              this.editPasswordModal = false
            } else {
              this.$Message.error(`更新密码失败：${response.data.msg}`)
            }
          }).catch(error => {
            msg()
            this.isSubmitDisabled = false
            if (error.response) {
              this.$Message.error('更新密码失败！')
            }
          })
        }
      })
    },
    handlePassword () {
      if (this.oldPassError !== '') {
        this.showEditPassword()
      }
    },
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isSubmitDisabled = true
          let msg = this.$Message.loading({
            content: '正在更新信息',
            duration: 0
          })
          const params = Object.assign({}, this.userDetail)
          params.roles = params.roleIds
          const data = {
            cscpUserDetailDTO: params,
            currentUserPwd: '',
            newPassword: ''
          }
          this.$http.put('/api/system/cscpUserDetails', data).then(response => {
            msg()
            this.$Message.success({
              content: '更新角色成功！',
              onClose: () => {
                this.closeMe()
              }
            })
          }).catch(error => {
            msg()
            this.isSubmitDisabled = false
            if (error.response) {
              this.$Message.error('更新角色失败！')
            }
          })
        }
      })
    },
    initRoles () {
      const [url, httpConfig] = [
        '/api/system/cscpRolessByCriteria',
        {
          params: { size: 1000 }
        }
      ]
      this.$http.get(url, httpConfig).then(response => {
        this.roleOptions = []
        for (const item of response.data.data) {
          this.roleOptions.push({
            value: item.id.toString(),
            label: item.name,
            icon: item.icon
          })
        }
      }).catch()
    },
    closeMe () {
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'home'
      })
    },
    handleChange1 (e) {
      let file = e.target.files[0]
      let reader = new FileReader()
      reader.onload = () => {
        this.cropper1.replace(reader.result)
        reader.onload = null
      }
      reader.readAsDataURL(file)
    },
    handlecrop1 () {
      if (!this.cropper1.getCroppedCanvas()) {
        return
      }
      let file = this.cropper1.getCroppedCanvas().toDataURL()
      if (file.length > 250 * 1024) {
        this.$Message.warning('选择的区域太大，超过了250K。请缩小选择区域！')
        this.showModal()
        return
      }
      this.option1.cropedImg = file
      this.userDetail.imgPath = file
    },
    showModal () {
      this.modalShow = true
    },
    valideRePassword (rule, value, callback) {
      if (value !== this.editPasswordForm.newPass) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    },
    /**
     * @description 校验手机号是否已存在
     */
    checkMobile(mobile) {
        return this.$http.get('/api/system/checkMobile?mobile='+mobile+'&username='+this.userDetail.username)
    }
  },
  created () {
    this.init()
  },
  mounted () {
    let img1 = document.getElementById('cropimg1')
    this.cropper1 = new Cropper(img1, {
      dragMode: 'move',
      preview: '#preview1',
      restore: false,
      center: false,
      highlight: false,
      aspectRatio: 1,
      cropBoxMovable: true,
      toggleDragModeOnDblclick: true
    })
    img1.addEventListener('crop', e => {
      this.cropdata1.x = parseInt(e.detail.x)
      this.cropdata1.y = parseInt(e.detail.y)
      this.cropdata1.w = parseInt(e.detail.width)
      this.cropdata1.h = parseInt(e.detail.height)
      this.cropdata1.deg = parseInt(e.detail.rotate)
      this.cropdata1.scaleX = parseInt(e.detail.scaleX)
      this.cropdata1.scaleY = parseInt(e.detail.scaleY)
    })
  }
}
</script>

<style lang="less">
@import '../authority/image-editor.less';
@import '../../styles/common.less';

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
